import { render, staticRenderFns } from "./CommissionDetails.vue?vue&type=template&id=588fc0de&scoped=true&"
import script from "./CommissionDetails.vue?vue&type=script&lang=js&"
export * from "./CommissionDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommissionDetails.vue?vue&type=style&index=0&id=588fc0de&prod&lang=less&scoped=true&"
import style1 from "./CommissionDetails.vue?vue&type=style&index=1&id=588fc0de&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588fc0de",
  null
  
)

export default component.exports